import { ROLES } from "./Roles";
export const SideBarDropdownData = [
   {
      menuName: "User",
      url: "/user",
      icon: "fa-user",
      roles: [ROLES.corporateAdmin, ROLES.management],
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/add-user",
            subDropdownList: [],
         },
         {
            subMenuName: "List",
            url: "/user-List",
            subDropdownList: [],
         },
      ],
   },
   {
      menuName: "Fleet Master",
      url: "/fleet-master",
      icon: "fa-truck",
      roles: [ROLES.corporateAdmin],
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/add-form",
            subDropdownList: [],
         },
         {
            subMenuName: "View",
            url: "/list",
            subDropdownList: [],
         },

         // {
         //    subMenuName: "Kilolitre Master",
         //    url: "/kiloleter-master",
         //    subDropdownList: [
         //       {
         //          subMenuName: "Add",
         //          url: "/add"
         //       },
         //       {
         //          subMenuName: "View",
         //          url: "/list"
         //       }
         //    ],
         // },


         {
            subMenuName: "Tonnage",
            url: "/tonnage",
            subDropdownList: [
               {
                  subMenuName: "Add",
                  url: "/add"
               },
               {
                  subMenuName: "View",
                  url: "/list"
               }
            ],
         },

         {
            subMenuName: "Vehicle Category",
            url: "/vehicle-category",
            subDropdownList: [
               {
                  subMenuName: "Add",
                  url: "/add"
               },
               {
                  subMenuName: "View",
                  url: "/list"
               }
            ],
         },


        
      ],
   },
   {
      menuName: "Driver Master",
      url: "/driver-master",
      icon: "fa-dharmachakra",
      roles: [ROLES.corporateAdmin],
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/add-form",
            subDropdownList: [],
         },
         {
            subMenuName: "View",
            url: "/view",
            subDropdownList: [],
         },
         {
            subMenuName: "Fleet Assignment",
            url: "/fleet-assignment",
            subDropdownList: [],
         },
      ],
   },
   {
      menuName: "Helper  Master",
      url: "/helper-master",
      icon: "fa-id-badge",
      roles: [ROLES.corporateAdmin],
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/add-form",
            subDropdownList: [],
         },
         {
            subMenuName: "View",
            url: "/view",
            subDropdownList: [],
         },
      ],
   },
   {
      menuName: "Customer Master",
      url: "/customer-master",
      icon: "fa-user",
      roles: [ROLES.corporateAdmin],
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/add-form",
            subDropdownList: [],
         },
         {
            subMenuName: "View",
            url: "/view",
            subDropdownList: [],
         },
      ],
   },
   // {
   //    menuName: "Vendor  Master",
   //    url: "/vendor-master",
   //    icon: "fa-tree",
   //    roles: [ROLES.corporateAdmin],
   //    dropdownList: [
   //       {
   //          subMenuName: "Add",
   //          url: "/add-form",
   //          subDropdownList: [],
   //       },
   //       {
   //          subMenuName: "View",
   //          url: "/view",
   //          subDropdownList: [],
   //       },
   //    ],
   // },
   // {
   //    menuName: "Lane Master",
   //    url: "/lane-master",
   //    icon: "fa-arrows-alt-h",
   //    roles: [ROLES.corporateAdmin],
   //    dropdownList: [
   //       {
   //          subMenuName: "Add",
   //          url: "/add-form",
   //          subDropdownList: [],
   //       },
   //       {
   //          subMenuName: "View",
   //          url: "/view",
   //          subDropdownList: [],
   //       },
   //    ],
   // },
   {
      menuName: "Contractor Master",
      url: "/contractor-master",
      icon: "fa-clipboard-list",
      roles: [ROLES.corporateAdmin],
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/add-form",
            subDropdownList: [],
         },
         {
            subMenuName: "View",
            url: "/view",
            subDropdownList: [],
         },
      ],
   },
   {
      menuName: "Location Master",
      url: "/location-master",
      icon: "fa-map-marker-alt",
      roles: [ROLES.corporateAdmin],
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/Add",
            subDropdownList: [],
         },
         {
            subMenuName: "View",
            url: "/view",
            subDropdownList: [
               // {
               //    subMenuName: "Add",
               //    url: "/add",
               // },
               // {
               //    subMenuName: "View",
               //    url: "/view",
               // }
            ],
         },
      ],
   },
   {
      menuName:"Company Master",
      url: "/company-master",
      icon: "fa-building",
      roles: [ROLES.corporateAdmin],
      dropdownList: [
         {
            subMenuName: "Add",
            url: "/add-form",
            subDropdownList: [],
         },
         {
            subMenuName: "View",
            url: "/view",
            subDropdownList: [],
         },
      ],
   },

   {
      menuName: "Trip",
      url: "/trip",
      icon: "fa-truck",
      roles: [ROLES.management, ROLES.supervisor,ROLES.corporateAdmin,ROLES.driver],
      dropdownList: [{
            subMenuName: "Contractual",
            url: "/contractual",
            subDropdownList: [
               {
                  subMenuName: "View",
                  url: "/view",
               },
            ],
         }
         // {
         //    subMenuName: "Adhoc",
         //    url: "/adhoc",
         //    subDropdownList: [
         //       {
         //          subMenuName: "View",
         //          url: "/view",
         //       },
         //    ],
         // },
         ]
   },
   
   {
      menuName: "Trip",
      url: "/trip",
      icon: "fa-truck",
      roles: [ROLES.manager],
      dropdownList: [{
            subMenuName: "Contractual",
            url: "/contractual",
            subDropdownList: [
               {
                  subMenuName: "Add",
                  url: "/add",
               },
               {
                  subMenuName: "View",
                  url: "/view",
               },
            ],
         }
         // {
         //    subMenuName: "Adhoc",
         //    url: "/adhoc",
         //    subDropdownList: [
         //       {
         //          subMenuName: "View",
         //          url: "/view",
         //       },
         //    ],
         // },
         ]
   },

   {  
      menuName:"Reports",
      url:"/reports",
      icon:"fa-list",
      roles:[ROLES.corporateAdmin,ROLES.management],
       dropdownList: [
         {
            subMenuName: "Loading Report",
            url: "/loading-report",
            subDropdownList: [],
         },
        
         {
            subMenuName: "Vehicle Shortage Summary Report",
            url: "/vehicle-shortage-summary-report",
            subDropdownList: [],
         },

         {
            subMenuName: "Trip Expenses Report",
            url: "/trip-expenses-report",
            subDropdownList: [],
         },

         {
            subMenuName: "Performance Report",
            url: "/performance-report",
            subDropdownList: [],
         },

         {
            subMenuName: "Monthly Loading Graph",
            url: "/monthly-loading-graph",
            subDropdownList: [],
         },
         {
            subMenuName: "EMI Report",
            url: "/emi-report",
            subDropdownList: [],
         },

      ]
   },
  


   // {
   //    menuName: "Create Adhoc Lane",
   //    url: "/adhoc-lane",
   //    icon: "fa-map-marker-alt",
   //    roles: [ROLES.management, ROLES.manager],
   //    dropdownList: [
   //       {
   //          subMenuName: "Add",
   //          url: "/add",
   //          subDropdownList: [],
   //       },
   //       {
   //          subMenuName: "View",
   //          url: "/view",
   //          subDropdownList: [],
   //       },
   //    ],
   // },
   // {
   //    menuName: "Create Adhoc Vendor",
   //    url: "/adhoc-vendor",
   //    icon: "fa-map-marker-alt",
   //    roles: [ROLES.management, ROLES.manager],
   //    dropdownList: [
   //       {
   //          subMenuName: "Add",
   //          url: "/add",
   //          subDropdownList: [],
   //       },
   //       {
   //          subMenuName: "View",
   //          url: "/view",
   //          subDropdownList: [],
   //       },
   //    ],
   // },
];

export const Roles = [
   // {
   //    value: 1,
   //    label: "Management",
   // },
   {
      value: 2,
      label: "Manager",
   },
];

const selectOptionData = [
   {
      label: "New/Nylon",
      value: 1,
   },
   {
      label: "New/Radial",
      value: 2,
   },
   {
      label: "Remold/Nylon",
      value: 3,
   },
   {
      label: "Remold/Radial",
      value: 4,
   },
];


export default selectOptionData;

export const fleetMasterFormTitle = [
   {
      label: "Vehicle Details",
      value: 0,
   },
   {
      label: "EMI",
      value: 1,
   },
   {
      label: "Service Record",
      value: 2,
   },
   {
      label: "Tyre",
      value: 3,
   },
   {
      label: "Monthly Maintenance Budget",
      value: 4,
   },
];

export const fleetMasterFormEdit = [
   {
      label: "Vehicle Details",
      value: 0,
   },
   // {
   //     label: "EMI",
   //     value: 1,
   // },
   {
      label: "Service Record",
      value: 1,
   },
   {
      label: "Tyre",
      value: 2,
   },
   {
      label: "Monthly Maintenance Budget",
      value: 3,
   },
];
export const locationData = [
   {
      label: "Kolkata",
      value: "Kolkata",
   },
   {
      label: "Delhi",
      value: "Delhi",
   },
   {
      label: "Patna",
      value: "Patna",
   },
];
export const originData = [
   {
      label: "Kolkata",
      value: "Kolkata",
   },
   {
      label: "Delhi",
      value: "Delhi",
   },
   {
      label: "Patna",
      value: "Patna",
   },
];
export const vehicleCategoryData = [
   {
      label: "20ft",
      value: "20ft",
   },
   {
      label: "22ft",
      value: "22ft",
   },
   {
      label: "24ft",
      value: "24ft",
   },
   {
      label: "32ft SXL",
      value: "32ft SXL",
   },
   {
      label: "32ft MXL",
      value: "32ft MXL",
   },
   {
      label: "Any Other",
      value: "Any Other",
   },
];

export const tonnageData = [
   {
      label: "5",
      value: "5",
   },
   {
      label: "6",
      value: "6",
   },
   {
      label: "7",
      value: "7",
   },
   {
      label: "8",
      value: "8",
   },
   {
      label: "9",
      value: "9",
   },
   {
      label: "10.5",
      value: "10.5",
   },
   {
      label: "15",
      value: "15",
   },
   {
      label: "18",
      value: "18",
   },
   {
      label: "any other",
      value: "any other",
   },
];

export const destinationData = [
   {
      label: "New York",
      value: "New York",
   },
   {
      label: "Paris",
      value: "Paris",
   },
   {
      label: "Tokyo",
      value: "Tokyo",
   },
   {
      label: "London",
      value: "London",
   },
];

export const makeData = [
   {
      label: "Tata",
      value: "Tata",
   },
   {
      label: "Eicher",
      value: "Eicher",
   },
   {
      label: "Ashok leyland",
      value: "Ashok leyland",
   },
];

export const customDataTableStyle = {
   table: {
      style: {
         border: "1px solid #007BFF", // Set border color
         borderRadius: "5px 5px 0 0",
      },
   },
   rows: {
      style: {
         //  minHeight: "72px", // override the row height
         border: "1px solid #007BFF",
      },
   },

   headCells: {
      style: {
         padding: "1rem ",
         backgroundColor: "#007BFF",
         color: "#fff",
         fontSize: "16px",
         fontWeight: "bold",
         marginBottom: "-1px",
      },
   },
   cells: {
      style: {
         padding: "0.2rem 1rem",
         //  borderRight: "1px solid #007BFF",
         fontSize: "14px",
      },
   },
};
